import { render } from "./Editor.vue?vue&type=template&id=bb968436"
import script from "./Editor.vue?vue&type=script&lang=js"
export * from "./Editor.vue?vue&type=script&lang=js"

import "./Editor.vue?vue&type=style&index=0&id=bb968436&lang=css"
script.render = render

export default script